// removed by extract-text-webpack-plugin
module.exports = {"dot":"dot__2Ingv"};


//////////////////
// WEBPACK FOOTER
// ./components/common/donut/donut.scss
// module id = 611
// module chunks = 68